// export const couleurs_egyptien.js
export const couleurs = {
  'km': {
    translation: 'Noir (La Terre noire)',
    translationEn: 'Black (the Black Land)',
    illustration: '𓆎𓅓', // I6 (km) + G17 (m)
    leadSign: 'I6',
    leadSignNote: 'I6 (morceau de peau de crocodile écailleuse) est un phonogramme bilitère qui porte à lui seul la valeur km ; G17 (chouette) n\'est qu\'un complément phonétique unilitère confirmant le m.',
    reading: 'Lecture analytique — km (I6-G17), « noir ». I6 est le signe directeur : il porte à lui seul la valeur bilitère km. G17 est un simple complément phonétique, confirmant le m. Copte ⲕⲁⲙⲉ, « noir » (voir la fiche « Km.t » dans Villes pour le champ comparatif africain complet sur cette racine).',
    readingEn: 'Analytical reading — km (I6-G17), "black". I6 is the lead sign: it alone carries the biliteral value km. G17 is a simple phonetic complement, confirming the m. Coptic ⲕⲁⲙⲉ, "black" (see the "Km.t" entry in Cities for the full comparative African field on this root).'
  }, // Km - Noir

  'ḥḏ': {
    translation: 'Blanc / Argent',
    translationEn: 'White / Silver',
    illustration: '𓌟𓏏𓏛' // T3 (ḥḏ: massue) + X1 (t) + Y1 (déterminatif) - ou simplement 𓌟 (T3)
  }, // Ḥḏ - Blanc / Clair

  'dšr': {
    translation: 'Rouge',
    translationEn: 'Red',
    illustration: '𓂧𓈙𓂋𓅞', // D46 (d) + N37 (š) + D21 (r) + G27 (flamant rose, dšr)
    leadSign: 'G27',
    leadSignNote: 'G27 (flamant rose, Phoenicopterus roseus) est le logogramme trilitère qui porte à lui seul la valeur dšr ; D46, N37 et D21 ne sont que des compléments phonétiques (d, š, r) qui la confirment. Wolof tërëx « flamant rose » ; wolof deret « sang » ; bambara dére « rouge ».',
    reading: 'Lecture analytique — dšr (D46-N37-D21-G27), « rouge, roux ». G27 (flamant rose) est le signe directeur : il porte à lui seul la valeur trilitère dšr, par son plumage même. D46 (d), N37 (š) et D21 (r) ne sont que des compléments phonétiques qui la confirment. Wolof tërëx, « flamant rose » ; bambara dére, « rouge ».',
    readingEn: 'Analytical reading — dšr (D46-N37-D21-G27), "red, russet". G27 (flamingo) is the lead sign: it alone carries the triliteral value dšr, through its very plumage. D46 (d), N37 (š) and D21 (r) are merely phonetic complements confirming it. Wolof tërëx, "flamingo"; Bambara dére, "red".'
  }, // Dšr - Rouge

  'dšr-variante': {
    translation: 'Rouge (variante, logogramme seul)',
    translationEn: 'Red (variant, logogram alone)',
    illustration: '𓅞', // G27 (flamant rose) seul
    leadSign: 'G27',
    leadSignNote: 'G27 (flamant rose) employé seul comme logogramme, sans complément phonétique.',
    reading: 'Lecture analytique — dšr (G27 seul), « rouge, roux » : le flamant rose employé seul comme logogramme, sans complément phonétique (voir la fiche « dšr » ci-dessus).',
    readingEn: 'Analytical reading — dšr (G27 alone), "red, russet": the flamingo used alone as a logogram, without a phonetic complement (see the "dšr" entry above).'
  }, // Dšr-variante - Rouge, logogramme seul

  'wꜣḏ': {
    translation: 'Vert / Bleu-vert',
    translationEn: 'Green / Blue-green',
    illustration: '𓇅𓏏𓏛' // M13 (wꜣḏ: tige de papyrus) + X1 (t) + Y1 (ou M13 seul : 𓇅)
  }, // Wꜣḏ - Vert / Prospérité

  'ḫntj': {
    translation: 'Jaune / Or (Couleur de peau / Pâte)',
    translationEn: 'Yellow / Gold (skin colour / paste)',
    illustration: '𓐍𓈖𓏏𓏭' // Aa1 (ḫ) + N35 (n) + X1 (t) + Z4/M17-M17 (y)
  }, // Ḫntj - Jaune

  'jꜣs': {
    translation: 'Bleu / Lapis-lazuli',
    translationEn: 'Blue / Lapis lazuli',
    illustration: '𓇋𓄿𓋴𓈓' // M17 (j) + G1 (Ꜣ) + S29 (s) + N33 (minéral/pierre)
  }, // Jꜣs - Bleu / Lapis-lazuli (ou ḫsbḏ : 𓐍𓋴bd𓈓 pour le lapis)


};

export default couleurs;

export {};